import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import RefreshIcon from '@material-ui/icons/Refresh'
const styles = theme => ({
  textField: {
    width: 220
  }
})
class EditCycleModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    cycle: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    dayStartDate: PropTypes.string.isRequired,
    updateCycle: PropTypes.func.isRequired
  }
  state = {
    cycle: {
      key: 0,
      startDate: void 0,
      endDate: void 0,
      breakPeriod: 0
    },
    cycles: [],
    isValid: false,
    errors: {}
  }
  updateState = nextState => {
    let isValid = true
    const errors = {}
    const { cycle } = nextState
    if (!cycle.startDate) {
      isValid = false
      errors.startDate = 'Ce champs est obligatoire'
    }
    if (moment(cycle.startDate).isAfter(moment())) {
      isValid = false
      errors.startDate = 'La date ne peut pas être dans le futur'
    }

    this.setState({ ...nextState, isValid: isValid, errors: errors })
  }
  handleOkClicked = () => {
    this.props.updateCycle(this.props.transaction, this.state.cycle)
  }
  handleResetBreak = e => {
    this.updateState({
      ...this.state,
      cycle: {
        ...this.state.cycle,
        breakPeriod: 0
      }
    })
  }
  handleEndDateChange = e => {
    const value = e.target.value
    this.updateState({
      ...this.state,
      cycle: { ...this.state.cycle, endDate: value }
    })
  }
  handleStartDateChange = e => {
    const value = e.target.value
    this.updateState({
      ...this.state,
      cycle: { ...this.state.cycle, startDate: value }
    })
  }
  handleBreakPeriodChange = e => {
    const value = e.target.value
    this.updateState({
      ...this.state,
      cycle: {
        ...this.state.cycle,
        breakPeriod: moment.duration(value).asMilliseconds()
      }
    })
  }
  componentDidMount() {
    const { cycle, transaction } = this.props
    if (cycle && transaction.pool.cycles) {
      const cycles = [...this.props.transaction.pool.cycles]
      this.setState({ cycle: { ...cycle }, cycles: cycles })
    }
  }
  minEndDate(cycle, cycles) {
    let date = moment(cycle.startDate)
    date.add(cycle.breakPeriod, 'ms')
    return date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
  }
  maxEndDate(cycle, cycles) {
    let date
    if (cycles[cycle.key + 1] && cycles[cycle.key + 1].endDate) {
      date = moment(cycles[cycle.key + 1].endDate)
      date.subtract(cycles[cycle.key + 1].breakPeriod, 'ms')
    } else if (cycles[cycle.key + 1]) {
      date = moment()
      date.subtract(cycles[cycle.key + 1].breakPeriod, 'ms')
    } else {
      date = moment()
    }
    return date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
  }
  minStartDate(cycle, cycles) {
    const minDayDate = moment(this.props.dayStartDate)
    let date
    if (cycles[cycle.key - 1] && cycles[cycle.key - 1].endDate) {
      date = moment(cycles[cycle.key - 1].endDate)
    } else {
      date = moment(minDayDate)
    }
    return date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
  }
  maxStartDate(cycle, cycles) {
    let date
    if (cycles[cycle.key + 1] && cycles[cycle.key + 1].endDate) {
      date = moment(cycles[cycle.key + 1].endDate)
      date.subtract(cycles[cycle.key + 1].breakPeriod, 'ms')
    } else {
      date = moment()
    }
    return date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
  }
  render() {
    const { classes, transaction } = this.props
    const { isValid, cycle, errors } = this.state
    const cycles = transaction.pool.cycles
    const isLast = this.props.cycle.key === transaction.pool.cycles.length - 1
    return (
      <ModalWrapper
        appBar
        open
        okDisabled={!isValid}
        onOk={this.handleOkClicked}
        title={
          isLast
            ? `Editer Cycle en cours`
            : `Editer Cycle ${this.props.cycle.key + 1}`
        }
        showOk>
        <Grid container direction="row" justify="center">
          <Grid item xs={12}>
            <TextField
              error={!!errors.startDate}
              helperText={errors.startDate ? errors.startDate : null}
              id="start-date"
              label="Date de début"
              type="datetime-local"
              className={classes.textField}
              onChange={this.handleStartDateChange}
              value={moment(cycle.startDate).format(
                moment.HTML5_FMT.DATETIME_LOCAL_SECONDS
              )}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                min: this.minStartDate(cycle, cycles),
                max: this.maxStartDate(cycle, cycles),
                step: 1 // seconds
              }}
            />
          </Grid>
          {!isLast ? (
            <Grid item xs={12}>
              <TextField
                error={!!errors.endDate}
                disabled={!cycle.endDate}
                helperText={errors.endDate ? errors.endDate : null}
                id="end-date"
                label="Date de fin"
                type="datetime-local"
                className={classes.textField}
                onChange={this.handleEndDateChange}
                value={
                  cycle.endDate
                    ? moment(cycle.endDate).format(
                        moment.HTML5_FMT.DATETIME_LOCAL_SECONDS
                      )
                    : ''
                }
                InputLabelProps={{
                  min: this.minEndDate(cycle, cycles),
                  max: this.maxEndDate(cycle, cycles),
                  shrink: true
                }}
                inputProps={{
                  step: 1 // seconds
                }}
              />
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <TextField
              id="time"
              label="Temps de pause"
              type="time"
              onChange={this.handleBreakPeriodChange}
              value={`${moment
                .utc(cycle.breakPeriod)
                .format(moment.HTML5_FMT.TIME_SECONDS)}`}
              className={classes.textField}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                step: 1 // seconds
              }}
            />
            <Button
              style={{ marginLeft: 4 }}
              variant="fab"
              mini
              color="secondary"
              onClick={this.handleResetBreak}>
              <RefreshIcon />
            </Button>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(EditCycleModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/EditCycleModal.js